import React, { useState } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Image } from "hesus-ui-kit";
import commentIcon from "@icons/ic-comment.svg";
import closeIcon from "@icons/ic-close.svg";
import { DivBackgroundOpacity } from "@utils/extra-style";

import {
  CommentButton,
  CommentsTitle,
  CloseButton,
  GroupComments,
  CommentsTextTitle,
  CommentText,
} from "./Comment.styled";
import { PopUpContainer, PopUpBox } from "@shared/styles/common.styled";

const Comment = (props) => {
  const { comment, t } = props;
  const [isCommentVisible, setCommentVisibility] = useState(false);

  const toggleComment = () => {
    setCommentVisibility(true);
  };

  const closeCommentPopup = () => {
    setCommentVisibility(false);
  };

  return (
    <div>
      <DivBackgroundOpacity opacity={comment.isActive === 1 ? 1 : "0.2"}>
        {(comment.internalComment || comment.quoteComment) && (
          <CommentButton onClick={toggleComment}>
            <Image src={commentIcon} alt="comment" styles={{ width: "24px" }} />
          </CommentButton>
        )}
      </DivBackgroundOpacity>
      {isCommentVisible && (
        <PopUpContainer>
          <PopUpBox>
            <div>
              <CommentsTitle>
                {t("REQUEST_MATCHINGS_LIST_COMMENTS_POP_UP")}
              </CommentsTitle>
              <CloseButton onClick={closeCommentPopup}>
                <Image src={closeIcon} alt="Close comment popup." />
              </CloseButton>
            </div>
            <GroupComments>
              <CommentsTextTitle>
                {t("SOLUTION_VIEW_PURCHASE_PRICE_ASSUMPTION")} :
              </CommentsTextTitle>
              <CommentText>{comment.internalComment ?? ""}</CommentText>
              <CommentsTextTitle>
                {t("SOLUTION_VIEW_SPECIFIC_CONDITIONS_CLIENT")} :
              </CommentsTextTitle>
              <CommentText>{comment.quoteComment ?? ""}</CommentText>
            </GroupComments>
          </PopUpBox>
        </PopUpContainer>
      )}
    </div>
  );
};

Comment.propTypes = {
  comment: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Comment);
